import { render, staticRenderFns } from "./DocumentSalesErrorList.vue?vue&type=template&id=0ed1fb60&scoped=true"
import script from "./DocumentSalesErrorList.vue?vue&type=script&lang=js"
export * from "./DocumentSalesErrorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed1fb60",
  null
  
)

export default component.exports